<template>
  <v-card-text>
    <v-layout column>
      <v-layout row wrap>
        <v-flex sm4="sm4" offset-sm1="offset-sm1" xs12>
          <v-card
            hover="hover"
            :class="{ selected: Plans.package === 1 }"
            @click="Plans.package = 1"
          >
            <v-card-title class="blue white--text">
              <h2 class="font-weight-light">Build Your On</h2>
              <v-spacer> </v-spacer>
              <h2 class="font-weight-light">{{ buildValue | currency }}</h2>
            </v-card-title>
            <v-card-text>
              <v-checkbox
                v-model="Plans.selectedModules"
                v-for="(module, index) in modules"
                :key="index"
                hide-details
                :value="module.moduleId"
                :readonly="module.moduleId === 1"
                color="primary"
              >
                <template slot="label">
                  <span>{{ module.moduleName }} - {{ module.price | currency }}</span>
                </template>
              </v-checkbox>
              <v-divider class="mt-2"> </v-divider>
              <v-checkbox
                class="mt-2"
                label="Customer Support"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Unlimit Training"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-divider class="mt-2"> </v-divider>
              <v-layout class="mt-2" align-center="align-center" justify-center row>
                <v-btn rounded color="primary" dark="dark" @click="packageChange(1)">
                  <v-icon dark="dark" v-if="Plans.package === 1">check</v-icon>Select</v-btn
                >
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex sm4="sm4" offset-sm1="offset-sm1" xs12>
          <v-card
            hover="hover"
            :class="{ selected: Plans.package === 2 }"
            @click="Plans.package = 2"
          >
            <v-card-title class="blue white--text">
              <h2 class="font-weight-light">Package</h2>
              <v-spacer> </v-spacer>
              <h2 class="font-weight-light">$80.00</h2>
            </v-card-title>
            <v-card-text>
              <v-layout align-center="align-center" justify-center row>
                <v-chip color="red" dark="dark">
                  <span class="font-weight-medium mx-3">most popular</span>
                </v-chip>
              </v-layout>
              <v-checkbox
                label="Inventory"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Repair"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Used Item"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Bill Payment"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Layway"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Multi Store"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Expense"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Customer Point System"
                readonly="readonly"
                hide-details
                color="primary"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Report Schedule"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Commisssion System"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Time Click"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-divider class="mt-2"> </v-divider>
              <v-checkbox
                class="mt-2"
                label="Customer Support"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-checkbox
                label="Unlimit Training"
                hide-details
                color="primary"
                readonly="readonly"
                input-value="true"
              >
              </v-checkbox>
              <v-divider class="mt-2"> </v-divider>
              <v-layout class="mt-2" align-center="align-center" justify-center row>
                <v-btn rounded color="primary" dark="dark" @click="packageChange(2)">
                  <v-icon dark="dark" v-if="Plans.package === 2">check</v-icon>Select</v-btn
                >
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout class="mt-5" row wrap>
        <v-btn color="info" text @click="cancel"> {{ $t("buttons.cancel") }}</v-btn>
        <v-spacer> </v-spacer>
        <v-btn color="info" text @click="back">{{ $t("buttons.back") }}</v-btn>
        <v-btn color="info" @click="nextStep">{{ $t("buttons.next") }} </v-btn>
      </v-layout>
    </v-layout>
  </v-card-text>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      defaultPrice: 80
    };
  },
  methods: {
    back() {
      this.$emit("back");
    },
    cancel() {
      this.$router.push({ name: "location-dashboard" });
    },
    nextStep() {
      this.$emit("nextStep");
    },
    packageChange(val) {
      this.Plans.package = val;
      if (val === 2) {
        this.Plans.softwareFee = this.defaultPrice;
      } else {
        this.Plans.softwareFee = this.buildValue;
      }
    }
  },
  watch: {
    buildValue(val) {
      if (val === 2) {
        this.Plans.softwareFee = this.defaultPrice;
      } else {
        this.Plans.softwareFee = val;
      }
    }
  },
  computed: {
    ...mapState("location", ["Plans"]),
    ...mapGetters("global", ["modules"]),
    buildValue() {
      let amount = 0;
      this.Plans.selectedModules.forEach(plan => {
        this.modules.forEach(module => {
          if (module.moduleId === plan) {
            amount = amount + module.price;
          }
        });
      });
      return amount;
    }
  }
};
</script>

<style scoped>
.selected {
  border-width: 3px;
  border-color: orange;
  border-radius: 6px;
  -moz-border-radius: 6px;
  -webkit-border-radius: 6px;
}
</style>
